export enum QueryKeys {
  Ping = 'pingData',
  User = 'userData',
  Users = 'usersData',
  OrganisationUsers = 'organisationUsersData',
  Organisation = 'organisationData',
  Organisations = 'organisationsData',
  Services = 'servicesData',
  Trainings = 'trainingsData',
  HealthCalls = 'healthCallsData',
  HealthSummary = 'healthSummaryData',
  HealthSummaryV2 = 'healthSummaryDataV2',
  HealthPlan = 'healthPlanData',
  CarePlan = 'carePlanData',
  Screening = 'screeningData',
  Consent = 'consentData',
  followUp = 'followUpData',
  ScreeningStatistics = 'screeningStatisticsData',
  HealthPlanOutcomes = 'healthPlanOutcomesData',
  CheckList = 'checkListData',
  TimeSlots = 'timeSlotsData',
  FeatureFlags = 'featureFlagsData',
  Cases = 'caseData',
  PortalCase = 'portalCaseData',
  SymptomProgress = 'symptomProgressData',
  SymptomProgressGraphs = 'symptomProgressGraphsData',
  HealthProgramStatistics = 'healthProgramStatisticsData',
  ScreeningInsights = 'screeningInsightsData',
  Testimonials = 'testimonialsData',
  Certification = 'certificationData',
  Policy = 'policyData',
}
